import logo from '@assets/logo.svg';
import { Loader } from '@atgfr8/atg-ui-tailwind';

export const AtgLoader = () => {
  return <Loader src={logo} />;
};
